import React from 'react';
import { Button, Modal, ModalBody, ModalHeader} from 'reactstrap';

const OfflinePopUp = (props) => {
    const handleProceed = () => {
        props.handleProceedOffline();
        props.toggleInfoPopup();
    }

    return (
        <Modal isOpen={props.showPopUpText} centered>
            <ModalHeader toggle={props.toggleInfoPopup} style={{borderBottom: "none"}}></ModalHeader>
            <ModalBody className="succ-body">
                <div className='wrapper text-center'>
                    <div className='w-100'>
                        <img className="ml-auto mr-auto succ-img" src={process.env.REACT_APP_IMAGES_PATH + "Exclamation.webp"} alt='limitexcede-icon'/>
                    </div>
                    <p className="offline-popup">UPI application amount exceeded.</p>
                    <p className="text-2 offline-popup-small">Maximum application amount through UPI is ₹5 lakhs.</p>
                    <p className="text-2 offline-popup-small">Revise your application amount to apply online through UPI.</p>

                    <Button onClick={props.toggleInfoPopup} className='online-btn'>Proceed Online</Button>

                    <p className="text-2 offline-popup-small">You can apply for more than ₹10 lakhs through Offline Process.</p>
                    <Button onClick={handleProceed} className='offline-btn'>Proceed Offline</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default OfflinePopUp;
